import About from './About/About';
import Footer from './Footer/Footer';
import Header from './Header/Header';
import Skills from './Skills/Skills';
import Testimonial from './Testimonial/Testimonial';
import Work from './Work/Work';

export { default as About } from "./About/About";
export { default as Footer } from "./Footer/Footer";
export { default as Header } from "./Header/Header";
export { default as Skills } from "./Skills/Skills";
export { default as Testimonial } from "./Testimonial/Testimonial";
export { default as Work } from "./Work/Work";


export const sections = [
    {
        id: 0,
        component: <Header />
    },
    {
        id: 1,
        component: <About />
    },
    {
        id: 2,
        component: <Work />
    },
    {
        id: 3,
        component: <Skills />
    },

    {
        id: 4,
        component: <Testimonial />
    },

    {
        id: 5,
        component: <Footer />
    },

];

